import dialogs from './misc/dialogs'
import { copyToClipboard } from './misc/clipboard'

export function useDialogs() {
  return dialogs
}

export { copyToClipboard }
